// removed by extract-text-webpack-plugin
module.exports = {"stats":"stats__15JjD","type":"type__3fTlK"};


//////////////////
// WEBPACK FOOTER
// ./components/Statistics.css
// module id = bvaU
// module chunks = 2